import * as React from 'react';
import { FiInfo } from 'react-icons/fi';
import PlatformAccordion from './PlatformAccordion';
import { Totals } from './Totals';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import 'bootstrap/js/src/collapse.js';
import { getSubtotalOfferItems } from '../../../../../../../../shared/functions/Functions';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../../store/rootReducer';
import { TotalTypes } from '../../../../../../../../enum/TotalTypes';
import TooltipOverlay from '../../../../../../../../shared/components/tooltip/Tooltip';

export default function OfferPlatformTable() {
    const { t } = useTranslation();
    const { campaign, initialOffer, isCharity } = useSelector((state: IAllStates) => state.offerBrand);

    return (
        <>
            <div className="overflow-auto table-offer-items">
                <Table responsive className="table-head-bg m-0 mt-1">
                    <thead className="table-head-bg">
                        <tr>
                            <th>{t('brand.campaign.book.offer.modal.platform')}</th>
                            <th className="text-center">{t('brand.campaign.book.offer.modal.followers')}</th>
                            <th className="text-center">
                                <div className="min-width-max-content d-flex align-items-center justify-content-center">
                                    {t('brand.campaign.book.offer.modal.avg_reach')}
                                    <TooltipOverlay
                                        className="ms-1 mb-0"
                                        content={t(`brand.campaign.book.offer.modal.avg_reachTooltip`)}
                                    >
                                        <FiInfo size={14} />
                                    </TooltipOverlay>
                                </div>
                            </th>
                            <th className="text-center">{t('brand.campaign.book.offer.modal.audience_per_country')}</th>
                            <th className={`${isCharity ? 'd-none' : 'text-center'}`}>
                                <div className="min-width-max-content d-flex align-items-center justify-content-center">
                                    CPM
                                    <TooltipOverlay
                                        className="ms-1 mb-0"
                                        content={t(`brand.campaign.book.offer.modal.cpmTooltip`)}
                                    >
                                        <FiInfo size={14} />
                                    </TooltipOverlay>
                                </div>
                            </th>
                            <th className={`${isCharity ? 'd-none' : 'text-end'}`} style={{ width: 150 }}>
                                {t('brand.campaign.book.offer.modal.price')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaign?.offerPlaceholder?.totalPlatforms?.map((platform, index) => (
                            <PlatformAccordion key={index} platform={platform} />
                        ))}
                    </tbody>
                </Table>
            </div>
            {!isCharity && (
                <div className="w-100 mt-2">
                    <Totals title={TotalTypes.OFFER_ITEMS} price={getSubtotalOfferItems(initialOffer?.offerItems)} />
                </div>
            )}
        </>
    );
}
